<script>
export default {
  name: "home-search",
  data() {
    return {
      search: "",
    };
  },
};
</script>

<template>
  <section id="home-search" class="home-search">
    <div
      class="d-flex justify-content-center flex-column align-items-center first"
    >
      <header>
        <h2>
          Movidos por Atender Bem
          <small>
            Nossas pessoas são fundamentais para o sucesso dessa receita!
          </small>
        </h2>
      </header>
    </div>
    <div class="d-flex justify-content-center flex-column align-items-center">
      <header>
        <h2>
          Confira nossas oportunidades! Se inscreva na vaga com mais <br />
          match ou deixe seu currículo em nosso banco.
          <small>
            Antes de se inscrever, lembre de conferir as regras de participação,
            que estão
            <div class="break"></div>
            disponíveis aqui nessa página!
          </small>
        </h2>
      </header>
      <div class="search d-flex justify-content-center align-items-center">
        <input
          type="text"
          placeholder="Pesquisar Oportunidades"
          v-model="search"
          @keypress.enter="search ? $router.push(`/vagas?busca=${search}`) : ''"
        />
        <button @click="search ? $router.push(`/vagas?busca=${search}`) : ''">
          &nbsp; <img src="@/assets/images/dpsp/icons/search.svg" alt="" />
        </button>
      </div>
    </div>
    <div class="container">
      <div class="wave row">
        <div class="col-lg-4 col-md-6">
          <div class="wave__box d-flex">
            <div class="banner">
              <img src="@/assets/images/dpsp/v-2.jpg" alt="" />
            </div>
            <router-link to="/vagas?area=Corporativo">
              Vagas | Corporativo
            </router-link>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 mt-4 mt-md-0">
          <div class="wave__box d-flex">
            <div class="banner">
              <img src="@/assets/images/dpsp/v-1.jpg" alt="" />
            </div>
            <router-link to="/vagas?area=Drogarias">
              Vagas | Drogarias
            </router-link>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 mt-4 mt-lg-0">
          <div class="wave__box d-flex">
            <div class="banner">
              <img src="@/assets/images/dpsp/v-3.jpg" alt="" />
            </div>
            <router-link to="/vagas?area=Centro de Distribuição">
              Vagas | Centro de Distribuição
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped src="../styles/search.scss"></style>